import React, { PureComponent } from 'react'
import { translate } from 'react-i18next'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'

import { pageData } from 'decorators'
import { Carousel } from 'components'
import GameTemplate from '../templates/GameTemplate'

import './Onboarding.css'

@pageData({ title: 'Onboarding' })
@translate()
@connect(
    null,
    {
        navigate: push
    }
)
export class Onboarding extends PureComponent {
    goToPresets = () => {
        this.props.navigate('/presets')
    }

    render() {
        return (
            <GameTemplate className="Onboarding darkmode-background">
                {/* <ImageAndText icon={{ name: 'big-car', style: { fontSize: '100px', lineHeight: '200px' } }} text={t('game.UNKNOWN.loadingText')} /> */}
                <Carousel onSkip={this.goToPresets} onFinish={this.goToPresets} />
            </GameTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Onboarding/Onboarding.js